/**
 * @deprecated This file is deprecated and should not be used for new query parameters. Please add new query parameters to the config file instead.
 * This file will be removed in the future, and all query parameters should be accessed via the config.
 * Please use the appQueryParams from the config file instead of importing from this file directly.
 */
export const APP_QUERY_PARAMS = {
  productStatus: 'status',
  searchTerm: 'searchTerm',
  openNode: 'node',
  reviewMode: 'showValidation',
  order: 'order',
  orderBy: 'orderBy',
  selectedTimeFrame: 'selectedTimeFrame',
  selectedTimeFrameStart: 'start',
  selectedTimeFrameEnd: 'end',
  maintenance: 'maintenance',
  mediaLibrary: 'showLibrary',
  registerToken: 'token',
  lang: 'lang',
  createNewRequest: 'createNewRequest',
  requestReplyOpen: 'requestReplyOpen',
  chainRequestReplyOpen: 'chainRequestReplyOpen',
  dismissRequest: 'dismissRequest',
  requestId: 'requestId',
  new: 'new',
  tour: 'tour',
  step: 'step',
  addLanguage: 'addLanguage',
  type: 'type',
  viewOption: 'viewOption',
  page: 'page',
  owner: 'owner',
  ownerId: 'ownerId',
};
